import { render, staticRenderFns } from "./ModalImprimirBoletim.vue?vue&type=template&id=4d4de0d0&"
import script from "./ModalImprimirBoletim.vue?vue&type=script&lang=js&"
export * from "./ModalImprimirBoletim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports